import DateFnsUtils from '@date-io/date-fns'
import { Grid, makeStyles, FormControl, FormHelperText, InputLabel, Input } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import CustomInput from '../../components/CustomInput'
import CustomSelect from '../../components/CustomSelect'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useLeadType } from '../../hooks/CompanyConfiguration/useLeadType'
import { useCustomer } from '../../hooks/Features/useCustomer'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { useLead } from '../../hooks/Features/useLeads'
import { formatDate, formatNumber, isValidUrl, ROUTES } from '../../shared/constants'
import { useHistory, useLocation } from 'react-router-dom'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import AddIcon from '@material-ui/icons/Add'
import { ProductContext } from '../../context api/Product/ProductContext'
import { useProduct } from '../../hooks/Features/useProduct'
import CustomCounter from '../../components/CustomCounter'
import CustomImage from '../../components/CustomImage'
import EditIcon from '../../assets/images/icons/edit.svg'
import classes from './Lead.module.css'
import CustomerGrid from './CustomerGrid'
import MailIcon from '@material-ui/icons/Mail'

export default function AddLeadProducts() {
  const [leadForm, setLeadForm] = useState({
    leadType: '',
    //leadStatus: '',
    followUpDate: new Date(),
    validity: new Date(),
    customer: '',
    wishList: {},
    totalPrice: 0,
    count: 0,
    status: '',
    discount: 0,
    customerDetails: {},
    leadTypeName: '',
    addedBy: '',
  })

  const params = useParams()
  const { addLead, loading } = useLead()
  const [remarks, setRemarks] = useState('')
  const history = useHistory()

  useEffect(() => {
    if (localStorage.getItem('lead')) {
      let tempForm = JSON.parse(localStorage.getItem('lead'))
      let tempProducts = {}
      let leadAmount = 0
      if (localStorage.getItem('leadProducts') && JSON.parse(localStorage.getItem('leadProducts')).flag == 'ADD') {
        tempProducts = JSON.parse(localStorage.getItem('leadProducts'))
        leadAmount = tempProducts.totalPrice
        if (tempForm.discountType === 'PERCENTAGE') leadAmount = ((leadAmount * (100 - tempForm.discount)) / 100).toFixed(2)
        else leadAmount -= tempForm.discount
      }
      tempForm = { ...tempForm, ...tempProducts }
      setLeadForm({
        ...tempForm,
        leadAmount,
      })
    } else {
      history.push(ROUTES.ADD_LEAD)
    }
  }, [])

  const handleAdd = (productId) => {
    let tempObj = {
      ...leadForm.wishList[productId],
      quantity: leadForm.wishList[productId].quantity + 1,
    }

    let totalPrice = leadForm.totalPrice + tempObj.productPrice
    let leadAmount = totalPrice
    if (leadForm.discountType === 'PERCENTAGE') leadAmount = ((leadAmount * (100 - leadForm.discount)) / 100).toFixed(2)
    else leadAmount -= leadForm.discount

    setLeadForm({
      ...leadForm,
      totalPrice,
      leadAmount,
      count: leadForm.count + 1,
      wishList: {
        ...leadForm.wishList,
        [productId]: tempObj,
      },
    })
  }

  const handleSubtract = (productId) => {
    if (leadForm.wishList[productId]) {
      let tempObj = {
        ...leadForm.wishList[productId],
        quantity: leadForm.wishList[productId].quantity - 1,
      }
      let tempPrice = leadForm.totalPrice - tempObj.productPrice
      let tempWishList = leadForm.wishList
      // if quantity =0 then remove from wishlist
      if (tempObj.quantity <= 0) delete tempWishList[productId]
      else {
        tempWishList[productId] = tempObj
      }
      // change total price, count of items, wishlist, and final leadAmount after discount
      let leadAmount = tempPrice
      if (leadForm.discountType === 'PERCENTAGE') leadAmount = ((leadAmount * (100 - leadForm.discount)) / 100).toFixed(2)
      else leadAmount -= leadForm.discount
      setLeadForm({
        ...leadForm,
        totalPrice: tempPrice,
        leadAmount,
        count: leadForm.count - 1,
        wishList: tempWishList,
      })
    }
  }

  const handleEditProducts = () => {
    localStorage.setItem('leadProducts', JSON.stringify({ ...leadForm, flag: 'ADD' }))
    history.push(ROUTES.SELECT_LEAD_PRODUCTS)
  }

  const handleAddLead = () => {
    let wishList = Object.keys(leadForm.wishList).map((item) => {
      return {
        productId: item,
        quantity: leadForm.wishList[item].quantity,
        productVariantId: leadForm.wishList[item].productVariantId,
      }
    })
    let finalLeadForm = {
      wishlist: wishList,
      customer: leadForm.customer,
      followUp: leadForm.followUpDate,
      leadStatus: 'ACTIVE',
      validity: leadForm.validity,
      totalDiscount: leadForm.discount,
      discountType: leadForm.discountType,
      leadAmount: leadForm.leadAmount,
      addedBy: leadForm.addedBy,
      remarks: remarks,
    }
    //console.log('final lead is ', finalLeadForm)
    addLead(finalLeadForm)
  }

  // //console.log('WISH LIST : ', leadForm.wishlist)

  return (
    <Layout heading="Leads" heading2="Add" url1={ROUTES.LEADS} none>
      <Grid container style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
        <Grid item lg={5}>
          <CustomerGrid
            leadTypeName="Hot"
            profilePicture={leadForm.customerDetails.profilePicture}
            customerState={leadForm.customerDetails.state}
            customerCity={leadForm.customerDetails.city}
            customerName={leadForm.customerDetails.name}
            editUrl={ROUTES.ADD_LEAD}
          />
        </Grid>

        <Grid item container lg={5} className={Object.keys(leadForm.wishList).length === 0 ? `${classes.addItemGrid} ${classes.contentCenterGrid}` : classes.finalLead}>
          {Object.keys(leadForm.wishList).length === 0 ? (
            <div
              className={classes.addItems}
              onClick={() => {
                localStorage.setItem('lead', JSON.stringify(leadForm))
                if (localStorage.getItem('leadProducts') && JSON.parse(localStorage.getItem('leadProducts')).flag != 'ADD') localStorage.removeItem('leadProducts')
                history.push(ROUTES.SELECT_LEAD_PRODUCTS)
              }}
            >
              <AddIcon className={classes.addIcon} />
              Add Items
            </div>
          ) : (
            <React.Fragment>
              <Grid item lg={5} className={classes.finalLeadLeftSection}>
                <div>Created On {formatDate(new Date())}</div>
                <div>modified on {formatDate(new Date())}</div>
                <br />
                <div>
                  Add Quote status
                  <br />
                  <div style={{ marginTop: '5px' }} className={classes.quoteStatus}>
                    Active
                  </div>
                  <br />
                  <FormControl>
                    <InputLabel htmlFor="remarks">Remarks</InputLabel>
                    <Input style={{ width: '8rem' }} id="remarks" aria-describedby="remarksHelper" onChange={(e) => setRemarks(e.target.value)} />
                  </FormControl>
                </div>
              </Grid>
              <Grid item lg={7} className={classes.finalLeadRightSection}>
                <div>
                  <strong>Summary</strong>
                </div>
                <div>
                  Price({leadForm.count} item{leadForm.count > 1 ? 's' : ''})<span className={classes.price}>{formatNumber(leadForm.totalPrice)}</span>
                </div>
                <div>
                  Selling Price
                  <span className={classes.price}>{formatNumber(leadForm.totalPrice)}</span>
                </div>

                <div>
                  Discount Offered
                  <span className={classes.price}>
                    {leadForm.discountType === 'AMOUNT' && '₹ '}
                    {leadForm.discount}
                    {leadForm.discountType === 'PERCENTAGE' && '%'} off -{formatNumber(leadForm.totalPrice - leadForm.leadAmount)}
                  </span>
                </div>

                <hr style={{ height: '1px', color: 'blue' }} />
                <div>
                  Total Amount
                  <span className={classes.price}>{formatNumber(leadForm.leadAmount)}</span>
                </div>
                <hr style={{ height: '1px', color: 'blue' }} />
                <div style={{ textAlign: 'center' }}>
                  {loading ? (
                    <Loader />
                  ) : (
                    <span onClick={handleAddLead} className={classes.quoteStatus}>
                      Add Lead
                    </span>
                  )}
                </div>
              </Grid>
            </React.Fragment>
          )}
        </Grid>
      </Grid>
      <br />
      {Object.keys(leadForm.wishList).length > 0 && (
        <div style={{ margin: '10px 50px' }}>
          <div>
            <strong>WishList</strong>
            <span style={{ float: 'right' }}>
              <CustomImage image={EditIcon} className={classes.icons} onClick={handleEditProducts} />
            </span>
          </div>
          <hr style={{ height: '1px', color: 'blue' }} />
          <Grid container>
            {Object.keys(leadForm.wishList).map((productId, index) => {
              let { name, productPrice, productImage, quantity, color } = leadForm.wishList[productId]
              return (
                <Grid className={classes.productGrid} item container lg={4}>
                  <Grid item lg={4}>
                    <div>
                      <img
                        src={isValidUrl(productImage) ? productImage : 'https://kohler.scene7.com/is/image/Kohler/KohlerLogoImage?$CorpSecondary$&crop=110,0,23778,16000&wid=590&hei=397'}
                        height="85px"
                        width="76px"
                        alt="logo"
                      />
                    </div>
                  </Grid>

                  <Grid item lg={4}>
                    <div>
                      {name}
                      <br />
                      Color: {color}
                      <br />
                      {formatNumber(productPrice)}
                    </div>
                  </Grid>

                  <Grid item lg={4}>
                    <CustomCounter value={quantity} handleAdd={() => handleAdd(productId)} handleSubtract={() => handleSubtract(productId)} />
                  </Grid>
                </Grid>
              )
            })}
          </Grid>
        </div>
      )}
    </Layout>
  )
}
